export default __webpack_public_path__ + "static/media/mandate.24409c61.svg";